import pickBy from 'lodash/pickBy';

export enum FileType {
  'application/pdf' = 'application/pdf',
  'application/vnd.apple.pkpass' = 'application/vnd.apple.pkpass',
}

export enum Target {
  '_blank' = '_blank',
  '_system' = '_system',
}

export const downloadFile = (fileName: string, data: any, type?: FileType, target?: Target) => {
  const url = window.URL.createObjectURL(new Blob([data], pickBy({ type })));
  const link = window.document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);

  if (target) {
    link.setAttribute('target', target);
  }

  window.document.body.appendChild(link);
  link.click();
  window.document.body.removeChild(link);
};
